import { ApiClient } from '../apiClient';
import type { PaymentTileSwitches } from '../../types/order';

// The checkout tiles an admin switched off (unavailable or hidden).
export class PaymentTilesService {
  constructor(private apiClient: ApiClient) {}

  async getSwitches(): Promise<PaymentTileSwitches> {
    return this.apiClient.get<PaymentTileSwitches>('/payments/tile-switches');
  }
}
